import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Page} from '../../../../shared/model/core/page.model';
import {PaginatedEntityCollectionReadOnlyService} from '../../service/paginatedEntityCollectionReadOnlyService';
import {AbstractFindManyPaginatedService} from '../../service/v2/service/findmany/abstractFindManyPaginated.service';
import {PageEvent} from '@angular/material/paginator';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
})
export class PaginationComponent<E> {

    @Output() pageChanged = new EventEmitter<number>();
    @Input() page: Page<any>;
    @Input() displayButtons = true;
    @Input() paginatedService: PaginatedEntityCollectionReadOnlyService<E, any> | AbstractFindManyPaginatedService<any, E>;
    @Input() totalItems = 0;
    @Input() pageSize = 0;
    @Input() pageIndex = 0;
    @Input() display: 'normal' | 'compact' = 'normal';

    onPageChanged(event: PageEvent) {
        if (this.paginatedService) {
            if (this.paginatedService instanceof PaginatedEntityCollectionReadOnlyService) {
                this.paginatedService.getPage(event.pageIndex);
            } else {
                this.paginatedService.changePage(event.pageIndex);
            }
        }
        this.pageChanged.emit(event.pageIndex);
        this.pageIndex = event.pageIndex;
    }

    get pagePageSize(): number {
        if (this.page) {
            return this.page.size;
        }
        if (this.paginatedService instanceof PaginatedEntityCollectionReadOnlyService) {
            return this.paginatedService.pageSize;
        } else {
            return this.paginatedService.pageable?.pageSize;
        }
    }

    protected readonly Math = Math;
}


